import moment from 'moment'
import type { RegionDailyAverageFilterEntity } from '../../domain/entities/RegionDailyAverageFilterEntity'

export class RegionDailyAverageFilterModel {
  regionId?: number
  startDate?: string
  endDate?: string
  page?: number
  limit?: number

  constructor(data: RegionDailyAverageFilterEntity) {
    this.regionId = data.region?.id
    this.page = data.page !== undefined ? data.page + 1 : undefined
    this.limit = data.limit
    this.startDate = data.dateRange?.[0]
      ? moment.utc(data.dateRange[0], 'YYYY-MM-DD').startOf('day').toISOString()
      : undefined
    this.endDate = data.dateRange?.[1]
      ? moment.utc(data.dateRange[1], 'YYYY-MM-DD').endOf('day').toISOString()
      : undefined
  }
}
